/**
 * Cache local dos contadores de navegação.
 *
 * Fica separado de `contadores.js` porque o módulo Vuex precisa lê-lo de forma
 * síncrona na inicialização — importar a store aqui criaria ciclo.
 */

export const STORAGE_KEY = 'veltacar_navegacao_contadores';

// Na prática os contadores são monotônicos: quem tem dado raramente volta a
// zero. Por isso um "tem tudo" vale muito mais tempo — reduz requisições e,
// principalmente, evita o item de menu sumir na frente do usuário.
const TTL_TUDO_PREENCHIDO = 24 * 60 * 60 * 1000; // 24h
const TTL_COM_VAZIOS = 5 * 60 * 1000; // 5min

export const lerCache = () => {
    try {
        const bruto = localStorage.getItem(STORAGE_KEY);
        if (!bruto) return null;

        const { contadores, salvoEm } = JSON.parse(bruto);
        if (!contadores || !salvoEm) return null;

        const ttl = Object.values(contadores).every(Boolean) ? TTL_TUDO_PREENCHIDO : TTL_COM_VAZIOS;
        return { contadores, expirado: Date.now() - salvoEm > ttl };
    } catch (e) {
        return null;
    }
};

export const gravarCache = (contadores) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ contadores, salvoEm: Date.now() }));
    } catch (e) {
        // Cache é acelerador, não fonte: quota cheia não é erro.
    }
};

export const limparCache = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // idem
    }
};
